var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-index-bar',_vm._l((_vm.floors),function(floor){return _c('div',{key:floor.name},[_c('van-index-anchor',{attrs:{"index":floor.name}}),_vm._l((floor.beds),function(bed){return _c('van-cell',{key:bed,attrs:{"title":bed},on:{"click":() => _vm.setBed(bed)}})})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }